<template>
  <div class="h5-upload clear">
    <template  v-if="staticSmallImg_mutiOneCase">
      <div class="img-item-staticBigImg_mutiOneCase fl">
        <van-image width="100%" lazy-load :src="staticSmallImg_mutiOneCase" @click="showViewImage(staticBigImg_mutiOneCase)">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
          <!--加载失败-->
          <template v-slot:error>加载失败</template>
        </van-image>
      </div>
      <div class="img-item-staticBigImg_mutiOneCase fl" v-for="(item, index) in fileList" :key="index">
        <van-image width="100%" lazy-load :src="item.content" @click="showViewImage(item.content)">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
          <!--加载失败-->
          <template v-slot:error>加载失败</template>
        </van-image>
        <div @click="deleteImg_mutiOneCase(index)" class="van-uploader__preview-delete"><i class="van-icon van-icon-cross van-uploader__preview-delete-icon"><!----></i></div>
      </div>
    </template>
    
    <van-uploader
      v-model="fileList"
      :after-read="afterRead"
      :max-count="maxCount"
      :before-delete="deleteImg"
      :class="{'staticSmallImg_mutiOneCase': !!staticSmallImg_mutiOneCase}"
      accept="image/*"
    >
      <div class="uploader">
        <div class="img-tips">
          <img :src="feedUpload" alt="" />
        </div>
      </div>
    </van-uploader>

    <van-image-preview v-model="show" :images="images"></van-image-preview>
  </div>


</template>

<script>
import feedUpload from '@/assets/image/settleAccount/icon-feedUpload@3x.png'

export default {
  name: "feedBackUpload",
  props: {
    maxCount: {
      type: Number,
      default: 9,
    },
    keyValue: {
      type: String,
      default: "",
    },
    id: {
      type:[Number, String],
      default:0
    },
    staticSmallImg_mutiOneCase: {
      type: String,
      default: '',
    },
    staticBigImg_mutiOneCase: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      feedUpload,
      images:null,
      show: false,
      fileList: [],
      capture: '' // ['camera']
    }
  },
  methods: {
    test(){
    },
    // 预览图片
    showViewImage(img){
      this.show = true
      this.images = Array.isArray(img) ? img : [img]
    },
    afterRead(file,name) {
      file.status = 'uploading'
      file.message = '上传中'
      const params = {
        file: file.file,
        key: this.keyValue,
        photoIndex:name.index
      };
      // 上传结束后的回调 YH000541
      params.uploadCallback = (res) => {
        if(res){
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      }

      this.$emit("afterRead", params);
    },
    deleteImg(file, name){
      //标识, 使用的商品的索引
      const photoIndex = name.index
      const params = {
        key: this.keyValue,
        photoIndex,
        id:file.file.fileId
      };
      this.$emit('delete',params)
      return true
    },
    deleteImg_mutiOneCase(photoIndex){
      const params = {
        key: this.keyValue,
        photoIndex,
        id:this.id
      };
      this.fileList.splice(photoIndex, 1)
      this.$emit('delete',params)
      return true
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .staticSmallImg_mutiOneCase .van-uploader__preview{
  display: none;
}
.img-item-staticBigImg_mutiOneCase {
  margin-bottom: 9px;
  width: 80px;
  // display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.img-item-staticBigImg_mutiOneCase:nth-child(2n+1){
  margin-right: 20px;
}
.img-item-0{
  margin-bottom: 0;
}
.uploader {
  width: 80px;
  height: 80px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  .img-tips {
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .desc {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
  }
}

.h5-upload {
  & /deep/ .van-uploader__wrapper{
    flex-wrap: wrap;
    margin-right:0;
  }
  & /deep/ .van-uploader {
    .van-uploader__preview {
      justify-content: space-between;
      flex-wrap: wrap;
      //margin-right:0;
      //margin-bottom:0;
      margin: 12px 0 0 12px;
    }

    .van-image {
      width: 80px;
      height: 80px;
      //margin-bottom: 5px;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .van-uploader__preview:nth-child(2n+1) {
      // margin-right: 20px;
    }
    .van-uploader__input-wrapper{
      justify-content: space-between;
      flex-wrap: wrap;
      //margin-right:0;
      margin: 12px 0 0 12px;
    }
    /deep/ .van-uploader__preview-delete {
      border-radius: 0 4px 0 8px !important;
    }

  }
}

.uploader{
  display: flex;
  justify-content: center;
  align-items: center
}
.h5-upload.clear{
  // background: #f2f2f2 !important;
  //width: 80px;
  //height: 80px;
  // height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ div {
  .van-uploader__input-wrapper{
    width: 80px !important;
    height: 80px !important;
    display: flex;
    justify-content: center !important;
    align-items: center;
    background: #f2f2f2;
    border-radius: 4px;
    .uploader{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img-tips{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0;
      img{
        margin-right: 0;
      }
    }
  }
}
</style>
